<template>
    <div>
        
    </div>
</template>

<script>
    export default {
        name: "login",
        props:{
            
        },
        components:{
         
        },
        data(){
            return {
                
            }
        },
        mounted() {
            console.log("子组件")
            console.log("this.$cookies.get('session_id')",this.$cookies.get('session_id'))

            var session_id = ''
            if(this.$cookies.get('session_id')){
                session_id = this.$cookies.get('session_id');
            }
            // 获取得到sessionId,则执行数据更新，说明刚刚进行授权
            if(session_id){
                console.log("执行session操作及获取用户")
                this.util.sessionid.set(session_id)
                this.getUserInfo()
                this.$cookies.remove('session_id')
            }else{
                console.log("没有session_id，不做任何执行")
            }
        },
        methods:{
            getUserInfo: function(e) {
                this.util.server.mini_user.info({
                    callback:(res => {
                        this.util.getUserId.set(res.data.user_id)
                        this.util.user_mobile.set(res.data.mobile);
                        this.util.globalData.user.set(res.data);
                    })
                })
            }
        }
    }
</script>
